import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import L from "./Lang";
import { Pop } from "./PopModal";
import Tick from "./Tick";

export default class CheckVer extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            version: null
        };
    }

    tick = async () => {
        try {
            let j = await qreq.getAsync('/api/version');
            if(j.item) {
                if(this.state.version !== null && this.state.version !== j.item) {
                    Pop.showConfirm(<L>New Version</L>,<><L>The portal version has changed from</L> <b>{this.state.version}</b> <L>to</L> <b>{j.item}</b>. <L>Please</L> <i><L>Confirm</L></i> <L>to refresh and view the newest version.</L></>, () => {
                        window.location.reload(true);
                    });
                }
                this.setState({ version: j.item });
            }
        }
        catch {}
      }

    render() {
        return <Tick onTick={this.tick} interval={10000} />;
    }
}